<template>
  <div class="app-header">
    <div class="app-header__inner">
      <!-- 品牌：点击回管理首页 -->
      <div class="app-header__brand" @click="homepay">
        <span class="app-header__mark">医</span>
        <span class="app-header__name">{{ configdata.projectname }}</span>
      </div>

      <!-- 客服热线：与登录页、页脚口径一致 -->
      <div class="app-header__service">
        <i class="el-icon-service app-header__icon"></i>
        <span class="app-header__phone">{{ servicePhone }}</span>
        <span class="app-header__time">工作日 9:00-18:00</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppHeader',
  data() {
    return {
      configdata: {}
    };
  },
  computed: {
    // 优先取客服专线，没有则退回服务电话
    servicePhone() {
      return this.configdata.servicephoneone || this.configdata.servicephone || '';
    }
  },
  created() {
    var configdata = JSON.parse(localStorage.getItem('configdata'))
    this.configdata = configdata || {}
  },
  methods: {
    // 点击品牌名回到管理首页
    homepay() {
      this.$router.push("/index")
    }
  }
};
</script>

<style scoped lang="css">
.app-header {
  position: sticky;
  top: 0;
  z-index: 999;
  background: #fff;
  border-bottom: 1px solid #ebeef5;
  /* 页头抬起来，与下方菜单形成层次 */
  box-shadow: 0 2px 8px rgba(31, 35, 41, 0.06);
}

.app-header__inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 64px;
  padding: 0 30px;
  box-sizing: border-box;
}

/* 品牌 */
.app-header__brand {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.app-header__mark {
  flex: none;
  width: 34px;
  height: 34px;
  margin-right: 10px;
  border-radius: 10px;
  background: linear-gradient(135deg, #f56c6c 0%, #e53935 100%);
  color: #fff;
  font-size: 17px;
  font-weight: bold;
  line-height: 34px;
  text-align: center;
}

.app-header__name {
  font-size: 20px;
  font-weight: 600;
  letter-spacing: 0.5px;
  color: #1d2129;
}

/* 客服热线：独立成浅灰信息块，与左侧品牌 logo 分开 */
.app-header__service {
  display: flex;
  align-items: center;
  padding: 7px 16px;
  border-radius: 10px;
  background: #f7f8fa;
}

.app-header__icon {
  margin-right: 8px;
  font-size: 18px;
  color: #f56c6c;
}

.app-header__phone {
  font-size: 20px;
  font-weight: bold;
  color: #2882FE;
}

.app-header__time {
  margin-left: 10px;
  font-size: 12px;
  color: #86909c;
}

@media screen and (max-width: 768px) {
  .app-header__inner {
    padding: 0 16px;
  }

  .app-header__service {
    padding: 5px 12px;
  }

  .app-header__name {
    font-size: 16px;
  }

  .app-header__time {
    display: none;
  }
}
</style>
